import React, {useEffect, useState} from 'react';
import LoadingButton from "../LoadingButton";
import {useDispatch, useSelector} from "react-redux";
import {setBlackURL, setImage, setManipulating, setRedURL, toggleRed} from "../../lib/slices/imageSlice";


// eslint-disable-next-line import/no-webpack-loader-syntax
import toggleRedWorker from 'workerize-loader!../../workers/toggleRed.worker.js';


export default function ToggleBlackButton(props) {

    const dispatch = useDispatch();

    // Redux states
    const isRed = useSelector(state => state.image.isRed);
    const currentURL = useSelector(state => state.image.currentURL);
    const manipulating = useSelector(state => state.image.manipulating);
    const redURL = useSelector(state => state.image.redURL);
    const blackURL = useSelector(state => state.image.blackURL);

    const [worker, setWorker] = useState(null);

    const handleMessage = (e) => {
        switch (e.data.type) {
            case 'imageData': handleReceiveImageData(e.data.data); break;
            default: break;
        }
    }
    const handleToggleRed = () => callToggleRed(currentURL);

    const handleReceiveImageData = (data) => {
        if (isRed)
            dispatch(setBlackURL(data));
        else
            dispatch(setRedURL(data));
        dispatch(setImage(data));
        dispatch(toggleRed());
    }

    const callToggleRed = () => {
        // Swap using stored data to be much quicker
        if (redURL && blackURL) {
            if (isRed) {
                dispatch(setImage(blackURL));
                dispatch(toggleRed());
            }
            else {
                dispatch(setImage(redURL));
                dispatch(toggleRed());
            }
        }

        // Generate a new image to switch to
        else {
            dispatch(setManipulating(true));
            if (!manipulating) {
                dispatch(setManipulating(true));
                worker.postMessage({
                    type: 'togglePixels',
                    url: currentURL,
                    isRed: isRed,
                })
            }
        }
    };

    // Initialize worker
    useEffect(() => {
        if (!worker) {
            const workerInstance = toggleRedWorker();
            workerInstance.addEventListener('message', handleMessage);
            setWorker(workerInstance);
        }
    }, []);

    return (
        <LoadingButton
            disabled={currentURL === undefined || manipulating}
            onClick={handleToggleRed}
        >
            Toggle Black
        </LoadingButton>
    );
}

